import { AuthApi } from '..';
import { axiosInsight } from '../axiosInstance';

export interface LoginPayload {
	username: string;
	password: string;
}

export const loginApi = async (data: LoginPayload) => {
	const res = await axiosInsight.post('/user/login', data);
	return res.data;
};

// export const checkUsernameApi = async (username: string) => {
// 	const res = await axiosInstance.post('/user/check-username', { username });
// 	return res.data;
// };

// export const logoutApi = async () => {
// 	const res = await axiosInstance.post('/user/logout');
// 	return res.data;
// };

export default AuthApi;
